module.exports = __webpack_public_path__ + "static/img/icon-7.db6c4814.png";